module.exports = __webpack_public_path__ + "static/media/Original Korean Excerpt from Guide - Introduction1.a1e87dec.pdf";